<template>
  <div class="cashflow-intro-information">
    <information button-title="איך התזרים שלי מחושב?" :button-action="next"
                 animation-name="cashflow-intro.json">
      <template v-slot:information-title>
        <div>תגידו ביי ביי לעו״ש</div>
        <div>והיי לתזרים החודשי</div>
      </template>
      <template v-slot:information-description>
        <div>
          <span>מהיום יש לך דרך חדשה להסתכל על הכסף שלך, התזרים החודשי! התזרים שלך נבנה כל חודש ומציג לך</span>
          <span class="bold">מספר אחד פשוט</span>
          <span>שעוזר לקבל החלטות</span>
        </div>
      </template>
    </information>
  </div>
</template>
<script>

import { mapActions } from 'vuex';
import Information from './components/Information';
import Segment from '../../../../../Segment';

export default {
  components: {
    Information,
  },
  name: 'CashflowIntroInformation',
  async created() {
    Segment.trackUserGot('infocashflowintroentered');
  },
  methods: {
    ...mapActions('onboardingState', ['onboardingPageSubmit']),
    next() {
      this.onboardingPageSubmit();
      Segment.trackUserInteraction('infocashflowintronextclicked');
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .cashflow-intro-information {
    height: 100%;

    .information {

      .body {
        background-color: $riseup_light_blue;
      }

      img {
        background-color: $riseup_light_blue;
      }

      lottie-player {
        background-color:  $riseup_light_blue;
      }
    }
  }

</style>
